import createCachedSelector from 're-reselect'
import { isDefined } from 'util/nullOrUndefinedChecks'
import { byProductFeatureCacheKey } from './byProductFeatureCacheKey'
import { selectBillingUsageForProductFeature } from './selectBillingUsageForProductFeature'
import { selectLocalUsageForProductFeature } from './selectLocalUsageForProductFeature'

export const selectUsageForProductFeature = createCachedSelector(
  selectBillingUsageForProductFeature,
  selectLocalUsageForProductFeature,
  (billingUsageAmount, localUsageAmount) => {
    // using local data first because we do not re-fetch billing usage after features have been added/deleted
    // this will be changing in the feature
    // would advice we send a realtime event when billing usage changes
    return isDefined(localUsageAmount) ? localUsageAmount : billingUsageAmount
  }
)(byProductFeatureCacheKey)
